import React from "react";
import { Message } from "@/types";
import sparkleIcon from "@/assets/sparkle.svg";
import AIResponse from "../AIResponse";
import UserMessage from "../UserMessage";

interface ChatMessageProps {
  message: Message;
}

/**
 * Renders a single chat message — either a user message or an AI response.
 * AI responses are prefixed with the sparkle assistant icon.
 */
export function ChatMessage({ message }: ChatMessageProps) {
  if (message.isUser) {
    return (
      <div>
        <UserMessage message={message} />
      </div>
    );
  }

  return (
    <div className="flex items-start gap-3">
      <img src={sparkleIcon} alt="AI" className="w-5 h-5 mt-1 flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <AIResponse message={message} />
      </div>
    </div>
  );
}

export default ChatMessage;
